module.exports = __webpack_public_path__ + "static/img/quit.a9287097.svg";